import React from 'react';
import { colorSet, clsx } from '@components/Provider';
import { CustomizedTypography } from '@components/Customized';
import {
  Avatar,
  Stepper,
  Step,
  StepLabel,
  makeStyles
} from '@material-ui/core';
import {
  AssessmentOutlined,
  ForumOutlined,
  AssignmentTurnedInOutlined
} from '@material-ui/icons';

const useStyles = makeStyles(() => {
  return {
    root: {
      padding: '16px 14px',
      '& .MuiStepConnector-alternativeLabel': {
        top: 13,
        left: 'calc(-50% + 10px)',
        right: 'calc(50% + 10px)',
        '& .MuiStepConnector-lineHorizontal': {
          borderTopStyle: 'dashed',
          borderTopWidth: 2
        }
      }
    },
    step: {
      padding: 0,
      '& .MuiTypography-caption': {
        color: colorSet.gray600
      },
      '& .MuiStepLabel-label': {
        marginTop: 6
      }
    },
    activeStep: {
      '& .MuiTypography-caption': {
        color: '#6ECA98'
      }
    },
    stepIcon: {
      width: 28,
      height: 28,
      backgroundColor: colorSet.gray000,
      border: `1px solid ${colorSet.gray400}`,
      zIndex: 1,
      '& .MuiSvgIcon-root': {
        width: 16,
        height: 16,
        color: colorSet.gray600
      }
    },
    activeStepIcon: {
      backgroundColor: '#6ECA98',
      border: 'none',
      '& .MuiSvgIcon-root': {
        color: colorSet.gray000
      }
    }
  };
});

interface Props {
  activeStep?: number;
}

const PurchaseOrderProgressPresenter: React.FC<Props> = ({ activeStep }) => {
  const classes = useStyles();

  const StepData: Array<{
    StepIcon: React.ReactNode;
    StepLabel: React.ReactNode;
  }> = [
    {
      StepIcon: <AssessmentOutlined />,
      StepLabel: (
        <CustomizedTypography variant="caption">견적확인</CustomizedTypography>
      )
    },
    {
      StepIcon: <ForumOutlined />,
      StepLabel: (
        <CustomizedTypography variant="caption">견적상담</CustomizedTypography>
      )
    },
    {
      StepIcon: <AssignmentTurnedInOutlined />,
      StepLabel: (
        <CustomizedTypography variant="caption">발주</CustomizedTypography>
      )
    }
  ];

  return (
    <Stepper className={classes.root} alternativeLabel>
      {StepData.map((item, index) => {
        const isActive = index === activeStep;
        return (
          <Step
            key={index}
            className={clsx(classes.step, {
              [classes.activeStep]: isActive
            })}
          >
            <StepLabel
              StepIconComponent={() => (
                <Avatar
                  className={clsx(classes.stepIcon, {
                    [classes.activeStepIcon]: isActive
                  })}
                >
                  {item.StepIcon}
                </Avatar>
              )}
            >
              {item.StepLabel}
            </StepLabel>
          </Step>
        );
      })}
    </Stepper>
  );
};

export default PurchaseOrderProgressPresenter;
